













import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import AxiosMixin from "../mixins/axiosMixin";
import { getDefaultMonth } from "@/types";
import Detail from "@/components/dashboard/detail.vue";
import LoadingDialog from "@/components/common/LoadingDialog.vue";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    Detail,
    LoadingDialog
  }
})
export default class BillingList extends mixins(AxiosMixin) {
  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;

  //データテーブル
  private tableItems: object[] = [];

  //=================================================================
  // 対象年月
  //=================================================================
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    localStorage.setItem("yearmonth", yearmonth);
    this.setYearmonth(yearmonth);
  }

  //=================================================================
  // 検索ボタン
  //=================================================================
  private search() {
    this.postJsonCheck(
      window.base_url + "/api/office/billinglistdetails/get",
      {
        yearmonth: this.yearmonth.replace("-", "")
      },
      res => {
        this.tableItems = res.data.billinglist;
      }
    );
  }

  //=================================================================
  // ダウンロードボタン
  //=================================================================
  private download() {
    const param = {
      table_items: this.tableItems
    };

    const fname = `請求一覧（詳細）_${this.yearmonth}.xlsx`;

    this.postJsonBlobRes(
      window.base_url + "/api/office/billinglistdetails/download",
      param,
      res => {
        const blob = new Blob([res.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
      }
    );
  }

  //=================================================================
  // マウント
  //=================================================================
  //画面表示で検索をかける
  mounted() {
    const ym = localStorage.getItem("yearmonth");
    this.yearmonth = ym ? String(ym) : getDefaultMonth().substr(0, 7);
    this.search();
  }
}
